import AclRoute from './AclRoute.container'

export default AclRoute
